import { useEffect, useState } from 'react';
import {
  contestDetailsWrapperStyle,
  contestWrapperStyle,
  dateDetailsWrapperStyle,
  imageWrapperStyle,
  participationDescriptionStyle,
  notParticipatedStyle,
  answersStyle,
  answersDetailsStyle,
  answersWrapperStyle
} from './ContestsStyles';
import { fetchWatchAndWinPlayerStatInCampaign } from 'src/services/apiRequests/WatchAndWinService';
import { useSearchParams } from 'next/navigation';
import { useAppStore } from 'src/hooks/useAppStore';
import { parseGameMapperId } from '../../../utils/watchAndWinUtils';

interface Contest {
  hasParticipated: boolean;
  logoUrl: string;
  date: string;
  gameMetaInfo: {
    name: string;
  };
  correctAnswers: number;
  totalQuestions: number;
}

interface ContestsData {
  contests: Contest[];
}

const Contests = () => {
  const [data, setContests] = useState<ContestsData | null>(null);
  const searchParams = useSearchParams();
  const gameMapperId = parseGameMapperId(
    searchParams.get('game_mapper_id') || ''
  );

  const { translations } = useAppStore();
  useEffect(() => {
    (async () => {
      const data = await fetchWatchAndWinPlayerStatInCampaign(
        gameMapperId as string
      );
      setContests(data);
    })();
  }, []);

  return (
    <>
      {data?.contests?.map((contest: any, id: number) => (
        <div
          css={contestWrapperStyle(contest.hasParticipated)}
          key={`${contest}-${id}`}>
          <div css={imageWrapperStyle}>
            <img src={`${contest.logoUrl}`} alt="" />
            <div css={dateDetailsWrapperStyle}>
              {new Date(contest?.date).toLocaleDateString('en-GB', {
                day: '2-digit',
                month: 'short'
              })}{' '}
              - {contest?.gameMetaInfo?.name}
            </div>
          </div>
          <div css={contestDetailsWrapperStyle}>
            {contest.hasParticipated ? (
              <div css={answersWrapperStyle}>
                {' '}
                <span css={answersStyle}>
                  {contest?.correctAnswers}/{contest?.totalQuestions}
                </span>{' '}
                <span css={answersDetailsStyle}>
                  {translations?.gamification?.ANSWERED_CORRECTLY}
                </span>
              </div>
            ) : (
              <div css={notParticipatedStyle}>
                {translations?.gamification?.DID_NOT_PARTICIPATE}
              </div>
            )}
            <div css={participationDescriptionStyle}>
              {contest.hasParticipated
                ? `${translations?.gamification?.ENTER_DRAW_MESSAGE}`
                : `${translations?.gamification?.ENTER_DRAW_CONDITION}`}
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default Contests;
